import { useAuth0 } from '@auth0/auth0-react';
import classNames from 'classnames/bind';
import { Navigate, useNavigate } from 'react-router-dom';
import Icon from '../../components/Icon/Icon';
import { IconName } from '../../components/Icon/utils/types';
import styles from './LogIn.module.scss';

const cx = classNames.bind(styles);

const LogIn = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  const navigate = useNavigate();

  const onSignUp = () => navigate('/signup');

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <div className={cx('login')}>
      <div className={cx('login__wrapper')}>
        <div className={cx('login__content')}>
          <div className={cx('login__logo')}>
            <Icon name={IconName.EdgarNextLogo} width={180} height={58} />
          </div>
          <div className={cx('login__body-container')}>
            <div className={cx('login__circle')} />
            <div className={cx('login__body')}>
              <div
                className={cx('login__switch')}
                style={{
                  backgroundImage:
                    'url(' +
                    require('../../assets/login/login-switches.png') +
                    ')',
                }}
              />
              <h1 className={cx('login__title')}>
                Improving filer{' '}
                <span className={cx('login__title--highlight')}>access</span>
              </h1>
              <section>
                <h2 className={cx('login__title-small')}>ENROLLMENT PERIOD</h2>
                <h3 className={cx('login__title-large')}>
                  March 24, 2025 to September 12, 2025
                </h3>
              </section>
              <section>
                <h2 className={cx('login__title-small')}>
                  COMPLIANCE REQUIRED TO FILE
                </h2>
                <h3 className={cx('login__title-large')}>September 15, 2025</h3>
              </section>
              <section className={cx('login__buttons')}>
                <div className={cx('login__button-wrapper')}>
                  <h2 className={cx('login__button-title')}>New to DFIN?</h2>
                  <button
                    className={cx('login__button')}
                    type="button"
                    onClick={onSignUp}
                  >
                    <span>Sign up</span>
                  </button>
                </div>
                <div className={cx('login__button-wrapper')}>
                  <h2 className={cx('login__button-title')}>
                    Have an existing DFIN account?
                  </h2>
                  <button
                    className={cx('login__button')}
                    type="button"
                    onClick={() => loginWithRedirect()}
                  >
                    <span>Log in</span>
                  </button>
                </div>
              </section>
            </div>
            <div
              className={cx('login__pseudo-modal')}
              style={{
                backgroundImage:
                  'url(' + require('../../assets/login/pseudo-modal.png') + ')',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogIn;
